export const CHANGE_CURRPAGE = 'header/change_curr_page'
export const CHANG_LOADING = 'header/chang_loading'